export * from './document-carousel-item';
export * from './document-carousel-item-bottom';

import { DocumentCarouselItemComponent } from './document-carousel-item';
import { DocumentCarouselItemBottomComponent } from './document-carousel-item-bottom';

export const DocumentAtoms = [
    DocumentCarouselItemComponent,
    DocumentCarouselItemBottomComponent
]